import * as React from 'react';
import { BrPageContext, BrComponentContext } from '@bloomreach/react-sdk';

const initialValue = Object.freeze({
    apiUrl: '',
    componentDefinitions: {},
    preview: false,
    pageModel: undefined,
    path: '',
    excludeSkuFromProductUrls: false,
    siteLogos: {
        main: '',
        small: '',
        mobile: '',
        alternative: '',
        reimbursable: '',
        reimbursableAlternative: '',
        payInstallmentsLogo: '',
        logoFooter: ''
    }
});
const VISITOR_COOKIE = '_visitor';
/**
 * Note: do not use BloomreachContext.Provider directly. Instead, import {
 * BloomreachProvider } from './BloomreachProvider'. It's in a separate module
 * to avoid a circular dependency between ../component-definitions and
 * ../containers.
 */ const BloomreachContext = /*#__PURE__*/ React.createContext(initialValue);
function useBloomreach() {
    return React.useContext(BloomreachContext);
}
/**
 * Wrap Contexts from BR SDK in a hook so they're easier to mock in tests
 */ function useBrPageContext() {
    return React.useContext(BrPageContext);
}
function useBrComponentContext() {
    return React.useContext(BrComponentContext);
}

export { BloomreachContext, VISITOR_COOKIE, initialValue, useBloomreach, useBrComponentContext, useBrPageContext };
//# sourceMappingURL=context.js.map
